import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySessionAttendeeTable from '@activities/components/tables/activity-session-attendee-table/activity-session-attendee-table.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';

@Component({
  name: 'bpc-activity-session-attendees',
  components: {
    'bpc-activity-session-attendee-table': ActivitySessionAttendeeTable,
  },
})
export default class ActivitySession extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get extendedFilterConfigName() {
    return this.accessControlConfig?.access_control_service === 'finddoc'
      ? 'extended-with-finddoc-sync'
      : 'extended';
  }
}
